import { createSlice } from "@reduxjs/toolkit";

const favorite = createSlice({
  name: "favorite",
  initialState: {
    favoriteList: [],
    isFavorite: false
  },
  reducers: {
    favoriteListValue: (state, action) => {
      state.favoriteList = action.payload.favoriteValue;
    },
    isFavoriteValue: (state, action) => {
      state.isFavorite = action.payload.favoriteValue;
    },
  },
});

export const {
  favoriteListValue,
  isFavoriteValue
} = favorite.actions;
export default favorite.reducer;
